module.exports = __webpack_public_path__ + "img/cityPartner1.d8103385.png";